/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import {
  Typography,
  Card,
  Grid,
  CardActionArea,
  CircularProgress,
} from '@material-ui/core';
import { Link } from 'react-router-dom';
import { Circle } from 'rc-progress';
import { connect } from 'react-redux';
import { Close, Check } from '@material-ui/icons';
import config from '../../../config';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '100%',
  },
  primary: {
    color: theme.palette.primary.main,
  },
  actionArea: {
    width: '100%',
    height: '100%',
  },
  actionRoot: {
    width: '100%',
    height: '100%',
  },
  title: ({
    padding: '1em',
    paddingTop: '0px',
    textAlign: 'center',
    fontSize: '20px',
  }),
  subtitle: ({
    fontSize: '17px',
    fontStyle: 'italic',
  }),
  center: {
    margin: 'auto',
  },
  circleContainer: {
    padding: '20px',
  },
  fullWidth: {
    width: '100%',
    maxWidth: '100%',
    textAlign: 'center',
  },
  percentageText: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: '100%',
  },
}));

const TotalUnitProgressWidget = ({
  data, darkMode, loadingResults,
}) => {
  const classes = useStyles();
  const [totalProgress, setTotalProgress] = useState(-1);
  const [goal, setGoal] = useState(null);
  const colorPrimary = darkMode ? config.darkColor : config.primaryColor;

  useEffect(() => {
    if (data !== undefined && data.length > 0) {
      let totalQuiz = 0;
      data[0].forEach((module) => {
        let totalUnits = 0;
        let quizPercent = 0;
        module.units.forEach((unit) => {
          totalUnits += 1;

          const isRise = unit.unit.isRise === true;

          if (isRise) {
            // ✅ Rise: si score présent (attempted/failed/etc.), on considère l'unité "faite"
            const hasScore = !!unit.result?.score && (
              unit.result.score.scaled != null
      || (unit.result.score.raw != null && unit.result.score.max != null)
            );

            if (hasScore || unit.verb) {
              quizPercent += 100;
            }
            return;
          }

          // Non-Rise: complétion classique
          if (unit.result?.completion) {
            quizPercent += 100;
            return;
          }

          // Fallback verbes
          if (unit.verb === 'passed' || unit.verb === 'completed') {
            quizPercent += 100;
          }
        });
        totalQuiz += quizPercent / totalUnits;
      });
      if (totalQuiz === 0) {
        setTotalProgress(0);
      } else {
        setTotalProgress(totalQuiz / data[0].length);
      }
      setGoal(data[1].elearningAttempts);
    }
  }, [data]);

  return (
    <Card direction="row" className={classes.root}>
      {!loadingResults ? (
        <CardActionArea
          component={Link}
          className={classes.actionRoot}
          to={{
            pathname: '/elearning/results',
          }}
        >
          <Grid className={classes.actionArea} container direction="row" alignItems="center" alignContent="center">
            <Grid container item xs={6} md={6} direction="column" alignItems="center" alignContent="center">
              <Grid className={classes.fullWidth} item xs={4} md={4}>
                <Typography variant="h5" component="h3" className={classes.title} aria-label="Total Unit Progress">
                  Program done
                </Typography>
              </Grid>
              <Grid item xs={4} md={4} className={classes.percentageText}>
                {totalProgress > -1
                  ? (
                    <Typography variant="h3" className={`${classes.center} ${classes.percentage}`}>
                      {`${Math.trunc(totalProgress)} %`}
                    </Typography>
                  )
                  : (
                    <Typography variant="h6" className={`${classes.center} ${classes.percentage}`}>
                      Loading..
                    </Typography>
                  )}
              </Grid>
              <Grid
                className={classes.fullWidth}
                item
                xs={4}
                md={4}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '1em',
                  gap: '10px',
                }}
              >
                <Typography
                  component="h4"
                  variant="body1"
                  className={classes.subtitle}
                  style={{
                    color: darkMode ? '#b9b9b9e9' : '#4F4F4F',
                    padding: '0px',
                    margin: '0px',
                  }}
                >
                  {goal !== null && goal >= 0 ? `Objective : ${goal}%` : 'Loading..'}
                </Typography>
                {totalProgress >= goal
                  ? (
                    <Check
                      style={{
                        padding: '0px',
                        margin: '0px',
                        color: '#62D562',
                      }}
                    />
                  )
                  : (
                    <Close
                      color="secondary"
                      style={{
                        padding: '0px',
                        margin: '0px',
                      }}
                    />
                  )}
              </Grid>
            </Grid>
            <Grid className={classes.circleContainer} item xs={6} md={6}>
              <Circle
                percent={totalProgress || 0}
                strokeWidth="9"
                trailWidth="9"
                strokeColor={totalProgress >= goal ? '#66DD66' : colorPrimary}
                style={{ width: '100%' }}
              />
            </Grid>
          </Grid>
        </CardActionArea>
      )
        : (
          <div
            style={{
              height: '200px',
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <CircularProgress />
          </div>
        )}
    </Card>
  );
};

TotalUnitProgressWidget.propTypes = {
  data: PropTypes.array.isRequired,
  darkMode: PropTypes.bool.isRequired,
  loadingResults: PropTypes.bool.isRequired,
};

function mapState(state) {
  const { darkMode } = state.ui;
  return {
    darkMode,
  };
}
export default connect(mapState, null)(TotalUnitProgressWidget);
